(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('docArticleEdit', {
        templateUrl: 'views/components/views/docArticleEdit/docArticleEdit.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'base64', 'modalService', 'docArticleEditService', function ($stateParams, stateService, translateService, base64, modalService, docArticleEditService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let docArticleKeyno = $stateParams.docarticle_keyno;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                docArticleKeyno: docArticleKeyno,
                edit: {},
                lockedSave: false,
                lockedDelete: false
            };

            vm.editor = {
                ready: true,
                style: {
                    div: {
                        minHeight: '150px',
                        height: '100vh',
                        //maxHeight: 'min(calc(100vh - 220px), 700px)',
                        maxHeight: 'calc(100vh - 220px)',
                    }
                },
                class: {
                    base: 'col-xs-12 col-sm-12 col-xl-12 col-xxl-12 sp-0',
                    label: 'col-xs-12 col-sm-2 col-xl-2 col-xxl-1 sp-0',
                    input: 'col-xs-12 col-sm-10 col-xl-10 col-xxl-11 sp-0',
                }
            };

            vm.onChange = function (value) {
                vm.model.edit.html_content_base64 = value;
            }

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await docArticleEditService.getEdit({ docarticle_keyno: docArticleKeyno }))[0];

                vm.model.edit.html_content_base64 = base64.urldecode(vm.model.edit.html_content_base64);
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                docArticleEditService.saveObj({
                    docarticle_keyno: vm.model.edit.docarticle_keyno,
                    title: vm.model.edit.title,
                    html_content: vm.model.edit.html_content_base64,
                    html_content_base64: base64.urlencode(vm.model.edit.html_content_base64),
                    docarticle_keyno_belongto: vm.model.edit.docarticle_keyno_belongto,
                    reg_portal_user_name: vm.model.edit.reg_portal_user_name,
                    reg_date: vm.model.edit.reg_date,
                    mod_portal_user_name: vm.model.edit.mod_portal_user_name,
                    mod_date: vm.model.edit.mod_date,
                    nbr_of_read: vm.model.edit.nbr_of_read,
                    docarticle_keyno_top: vm.model.edit.docarticle_keyno_top
                }).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(function () {
                    docArticleEditService.deleteItem({ docarticle_keyno: vm.model.edit.docarticle_keyno }).then(function (response) {
                        if (response[0].errorcode !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                        		message: response[0].errormessage,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: function (dialogItself) {
                        				dialogItself.close();
                        				vm.model.lockedDelete = false;
                        			}
                        		}]
                        	});
                        } else {
                        	vm.model.lockedDelete = false;
                            stateService.back('2');
                        }
                    }, function () {
                        vm.model.lockedDelete = false;
                    });
                }, function () {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
